<template>
  <organistion-list />
</template>

<script>
  import OrganistionList from '@/components/organisation/OrganistionList.vue'

  export default {
    components: {
      OrganistionList
    }
  }
</script>
